export enum EmrPersistenceType {
    EligibilityBased = 1,
    PatientBased = 2,
}

export const EmrPersistenceTypeLabelMap: Record<EmrPersistenceType, string> = {
    [EmrPersistenceType.EligibilityBased]: 'Eligibility Based',
    [EmrPersistenceType.PatientBased]: 'Patient Based',
};

export const EmrPersistenceTypeDescriptionMap: Record<EmrPersistenceType, string> = {
    [EmrPersistenceType.EligibilityBased]:
        'MRN changes from admission to admission.',
    [EmrPersistenceType.PatientBased]:
        'Patient MRN is persisted across all admissions.',
};

export const emrPersistenceTypeOptions = Object.values(EmrPersistenceType)
    .filter((value): value is EmrPersistenceType => typeof value === 'number')
    .map((value) => ({
        label: EmrPersistenceTypeLabelMap[value],
        value,
    }));

export interface EmrDetailsDto {
    id: string;
    name: string;
    persistenceType: EmrPersistenceType;
    hospiceOrganizationId: string;
}